export const student = [
  {
    name: "Jenny Wilson",
    studentId: "ELRN-254264",
    course: "3D Character Creation",
    enrolledDate: "June 01, 2022",
    status: "complete",
  },
  {
    name: "Jeevan",
    studentId: "ELRN-254265",
    course: "3D Character Creation",
    enrolledDate: "June 01, 2025",
    status: "closed",
  },
  {
    name: "vishnu",
    studentId: "ELRN-254268",
    course: "3D Character Creation",
    enrolledDate: "June 05, 2025",
    status: "running",
  },
  {
    name: " Wilson",
    studentId: "ELRN-254264",
    course: "3D Character Creation",
    enrolledDate: "June 01, 2022",
    status: "complete",
  },
];
